export default {
    signingIn: 'Вход в систему...',
    missingRequiredCondoParams: 'Отсутствуют обязательные параметры: "condoUserId", "condoOrganizationId" или "organizationId"',
    missingRequiredAuthParams: 'Отсутствуют обязательные параметры: "code" и "state"',
    authError: 'Ошибка аутентификации',
    initializing: 'Инициализация...',
    organizationNotFound: 'Не удалось получить данные текущей организации.',
}